import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams, HttpParameterCodec } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { getHeaders } from '../utils/headers.functions';
import { MatDialog } from '@angular/material/dialog';

// Encoder personalizado para HttpParams que preserva espacios y caracteres especiales
class CustomEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }
  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }
  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}

const BASE_URL: string = environment.API_URL;
@Injectable({
    providedIn: 'root'
})
export class ProductsService {
    sharedVideo(body: { name: any; path: any; }) {
        return this.http.post<any>(`${BASE_URL}/upload-vimeo`, body);
    }
    uploadVideoModulo(formData: FormData): Observable<any> {
        const httpOptions = {
            reportProgress: true,  // Para obtener el progreso de la subida
            observe: 'events' as const, // Aseguramos que observe es de tipo 'events'
            responseType: 'json' as const  // Para asegurarnos de que la respuesta sea JSON
        };

        return this.http.put<any>(`${BASE_URL}/upload-video`, formData, {
            reportProgress: httpOptions.reportProgress,
            observe: httpOptions.observe,
            responseType: httpOptions.responseType
        });
    }

    public getVideos(body: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/onboarding/getVideoByName`, body);
    }


        /**
         * ================================
         * Gestión de Embudos (CRUD)
         * ================================
         */
        
        /** Crear un nuevo embudo */
        public createFunnel(funnelData: any): Observable<any> {
            const headers: HttpHeaders = getHeaders();
            return this.http.post<any>(`${BASE_URL}/funnel`, funnelData, { headers });
        }

        /** Actualizar un embudo existente */
        public updateFunnel(funnelData: any): Observable<any> {
            const headers: HttpHeaders = getHeaders();
            return this.http.put<any>(`${BASE_URL}/funnel`, funnelData, { headers });
        }

        /** Eliminar (desactivar) un embudo */
        public deleteFunnel(funnelId: number): Observable<any> {
            const headers: HttpHeaders = getHeaders();
            return this.http.delete<any>(`${BASE_URL}/funnel/${funnelId}`, { headers });
        }

        /** Obtener un embudo por ID */
        public getFunnelById(funnelId: number): Observable<any> {
            const headers: HttpHeaders = getHeaders();
            return this.http.get<any>(`${BASE_URL}/funnel/${funnelId}`, { headers });
        }

        /** Obtener embudos por usuario administrador */
        public getFunnelsByUserId(adminId: number): Observable<any[]> {
            const headers: HttpHeaders = getHeaders();
            return this.http.get<any[]>(`${BASE_URL}/funnels/${adminId}`, { headers });
        }

        /**
         * ================================
         * Widgets/Módulos de Embudos
         * ================================
         * Endpoints disponibles:
         * - GET    /funnels/:funnelId/modules (obtener widgets de embudo)
         * - POST   /funnels/:funnelId/modules (guardar widgets de embudo)
         */

        /** Obtiene los widgets/módulos de un embudo */
        public getFunnelModules(funnelId: number): Observable<any[]> {
            const headers: HttpHeaders = getHeaders();
            return this.http.get<any[]>(`${BASE_URL}/funnels/${funnelId}/modules`, { headers });
        }

        /** Guarda los widgets/módulos de un embudo */
        public saveFunnelModules(funnelId: number, widgetsData: any): Observable<any> {
            const headers: HttpHeaders = getHeaders();
            return this.http.post<any>(`${BASE_URL}/funnels/${funnelId}/modules`, widgetsData, { headers });
        }

        /** Guarda los valores de los campos del lead */
        public saveLeadFieldValues(leadId: number, fieldValues: any[]): Observable<any> {
            const headers: HttpHeaders = getHeaders();
            const body = { fieldValues: fieldValues };
            return this.http.post<any>(`${BASE_URL}/leads/${leadId}/field-values`, body, { headers });
        }

        /** Obtiene los valores guardados de los campos del lead */
        public getLeadFieldValues(leadId: number): Observable<any> {
            const headers: HttpHeaders = getHeaders();
            return this.http.get<any>(`${BASE_URL}/leads/${leadId}/field-values`, { headers });
        }
    public changeStatusVideo(videoId: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.delete<any>(`${BASE_URL}/onboarding/finishVideo/${videoId}`);
    }
    updateTopic(id: any, newtopic: { videoUrl: any; }) {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/altertopics/${id}`, newtopic, { headers });
    }

    public currentUser: any;

    constructor(
        private http: HttpClient,
        private router: Router

    ) {
        this.currentUser = this.userValue;
    }

    public get userValue(): any {
        return JSON.parse(localStorage.getItem('currentUser') ?? '{}');
    }

    public sendMail(formData: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/eventEmail`, formData);
    }

    public uploadImg(formData: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/uploadimg`, formData);
    }

    /**
     * Sube una imagen de perfil usando la nueva API auth/profile/photo
     * @param formData FormData con el archivo de imagen (campo: 'photo')
     * @returns Observable con la respuesta que incluye la URL de la imagen subida
     */
    public uploadProfilePhoto(formData: FormData): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/auth/profile/photo`, formData, { headers })
            .pipe(
                catchError((err) => {
                    const status = err?.status;
                    const msg = err?.error?.message || err?.message;
                    if (status === 413) {
                        return throwError(() => ({ status, message: 'El archivo es demasiado grande para el servidor.' }));
                    }
                    if (status === 400 && msg) {
                        return throwError(() => ({ status, message: msg }));
                    }
                    return throwError(() => ({ status: status || 500, message: msg || 'No se pudo subir la imagen de perfil.' }));
                })
            );
    }

    public uploadFile2(formData: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/uploadfile`, formData);
    }

    setCoursePreview(uuid: string, id: number) {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/masteracc/${uuid}`, { productid: id }, { headers });
    }

    validateActivation(productId: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/validate-products/${productId}`, { headers });
    }

    public uploadFile(formData: any, productId: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/saveDocument/${productId}`, formData, { headers });
    }

    public uploadFileWithoutID(formData: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/uploadarchive`, formData, { headers });
    }

    public createFeature(feature: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/catalogs`, feature, { headers });
    }

    public updateFeature(id: number, feature: any): Observable<any> {
        const buildFeature = this.editFeature(feature);
        const updatedFeature = this.addBackendStructureFeature(buildFeature);
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/catalog/${id}`, updatedFeature, { headers });
    }

    public getFeatures(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${'Feature'}`, { headers });
    }

    public deleteFeature(id: number): Observable<any> {
        return this.http.delete<any>(`${BASE_URL}/catalog/${id}`);
    }

    public getCatalogs(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs`, { headers });
    }

    public getCatalogsName(name): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${name}`, { headers });
    }

    public postCatalogs(body): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/catalogs/`, body, { headers });
    }

    public getValuestoCatalog(Catalog: string): Observable<any> {
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${Catalog}`);
    }

    public getValue(id: string | number): Observable<any> {
        return this.http.get<any>(`${BASE_URL}/catalog/${id}`);
    }

    public getCatalogsAlias(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-alias`, { headers });
    }

    public getSpecifications(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${'Specification'}`, { headers });
    }

    public getFamilies(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${'Family'}`, { headers });
    }

    public getCategories(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${'Category'}`, { headers });
    }

    public getSubCategories(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/${'Subcategory'}`, { headers });
    }

    public getCourses(page: number = 1, limit: number = 10): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/courses?page=${page}&limit=${limit}`, { headers });
    }

    public getCourses2(search: string, id: any, page: number = 1, limit: number = 10, filters: any = {}): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
        const isAdmin = user.roles === 'admin';
        
        // Construir query params
        const params = new URLSearchParams();
        
        // Agregar paginación
        params.append('page', page.toString());
        params.append('limit', limit.toString());
        
        if (search) params.append('search', search);
        
        // 🔥 IMPORTANTE: NO enviar user_id si es admin
        // El JWT token tiene prioridad, y si enviamos user_id, solo veremos los cursos del admin
        // Si NO enviamos user_id y somos admin, el backend mostrará TODOS los cursos
        if (id && !isAdmin) {
            params.append('user_id', id.toString());
            console.log('📋 user_id agregado al query (cursos):', id);
        } else if (isAdmin) {
            console.log('👤 Admin detectado - NO se envía user_id para ver todos los cursos');
        }
        
        console.log('🔍 Query completo para cursos:', params.toString());
        
        return this.http.get<any>(`${BASE_URL}/courses?${params.toString()}`, { headers });
    }

    public getEbooks2(search: string, id: any, page: number = 1, limit: number = 10, filters: any = {}): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
        const isAdmin = user.roles === 'admin';
        
        // Construir query params
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('limit', limit.toString());
        if (search) params.append('search', search);
        
        // Enviar user_id solo para dueños de catálogo; admin ve todos (JWT sin filtro en backend)
        if (id && !isAdmin) {
            params.append('user_id', id.toString());
            console.log('📋 user_id agregado al query (ebooks):', id);
        } else if (isAdmin) {
            console.log('👤 Admin detectado - NO se envía user_id para ver todos los ebooks');
        }
        
        // Si es admin y NO se especificó Status, agregar filtro de estado (enviados a revisión)
        // Esto es SOLO para admins cuando entran por primera vez sin filtros
        if (isAdmin && !filters.Status && !this.hasAnyFilter(filters)) {
            params.append('Status', 'revisión');
        }
        
        // Filtros adicionales (solo agregar si existen)
        if (filters.Status) params.append('Status', filters.Status);
        if (filters.category_id) params.append('category_id', filters.category_id.toString());
        if (filters.level_id) params.append('level_id', filters.level_id.toString());
        if (filters.orderBy) params.append('orderBy', filters.orderBy);
        if (filters.orderDirection) params.append('orderDirection', filters.orderDirection);
        
        console.log('🔍 Query completo para ebooks:', params.toString());
        
        return this.http.get<any>(`${BASE_URL}/ebooks?${params.toString()}`, { headers });
    }

    private hasAnyFilter(filters: any): boolean {
        return filters.category_id || filters.level_id || filters.orderBy;
    }

    public getCategoriesCatalog(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/category`, { headers });
    }

    public getLevels(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/catalogs-data/level`, { headers });
    }

    public getEbookById(ebookId: string): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/ebooks/${ebookId}`, { headers });
    }

    public getCourseById(courseId: string): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/course/${courseId}`, { headers });
    }

    public deleteCourses(productId: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.delete<any>(`${BASE_URL}/course/${productId}`, { headers });
    }

    public sendCourseToReview(courseId: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/course/${courseId}/send-to-review`, {}, { headers });
    }

    public deleteEbooks(productId: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.delete<any>(`${BASE_URL}/ebooks/${productId}`, { headers });
    }

    public sendEbookToReview(ebookId: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/ebooks/${ebookId}/send-to-review`, {}, { headers });
    }

    public getCapacitations(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/products?Family=${'Capacitation'}`);
    }

    public getWebinars(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/products?Family=${'Webinar'}`);
    }
    public getEvents(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/products?Family=${'Event'}`);
    }

    public getProduct(productId: string): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/course/${productId}`, { headers });
    }

    public getProduct2(productId: string): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/course/${productId}`, { headers });
    }

    public getProductsFiltered(family: string): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/products-filter?family=${family}`);
    }

    public createCourse(product: any): Observable<any> {
        const user = JSON.parse(localStorage['currentUser']);
        const headers = new HttpHeaders().set('Accept', 'application/json').set("Authorization", user.token);
        return this.http.post<any>(`${BASE_URL}/course`, product, { headers });
    }

    public updateCourse(id: number, product: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/course/${id}`, product, { headers });
    }

    public updateCourse2(id: number, product: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/course/${id}`, product, { headers });
    }

    public updateCourseForReview(id: number, product: any): Observable<any> {
        // Si es FormData, no establecer Content-Type (el navegador lo hará automáticamente con boundary)
        if (product instanceof FormData) {
            const headers: HttpHeaders = new HttpHeaders({
                'Authorization': `Bearer ${localStorage.getItem('token') || sessionStorage.getItem('token')}`
            });
            return this.http.put<any>(`${BASE_URL}/course/${id}`, product, { headers });
        }
        // Si es objeto JSON normal
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/course/${id}`, product, { headers });
    }

    public updateEbook(id: number, product: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/ebooks/${id}`, product, { headers });
    }

    public updateEbook2(id: number, product: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/ebooks/${id}`, product, { headers });
    }

    public publishEbook(ebookId: number): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/ebooks/${ebookId}/publish`, {}, { headers });
    }

    public publishCourse(courseId: number): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/course/${courseId}/publish`, {}, { headers });
    }

    public deleteProduct(id: number): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.delete<Observable<any>>(`${BASE_URL}/products/${id}`, { headers });
    }

    public inicializarEbook(body: any): Observable<any> {
        if (this.currentUser) {
            const userid = this.currentUser.id;
            body.userid = userid;
            const httpOptions = {
                headers: new HttpHeaders({
                    'Authorization': this.currentUser.token
                })
            };
            return this.http.post<any>(`${BASE_URL}/ebooks`, body, httpOptions);
        }
    }

    // 🆕 NUEVO: Crear ebook con archivo PDF en una sola petición (multipart/form-data)
    public crearEbookConArchivo(formData: FormData): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        // NO incluir Content-Type, el navegador lo configura automáticamente con el boundary
        return this.http.post<any>(`${BASE_URL}/ebooks`, formData, { headers });
    }

    public enviarEbook(body): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        // Guardar metadata adicional del ebook (archivo PDF)
        return this.http.post<any>(`${BASE_URL}/ebooks/${body.ProductId}/file`, body, { headers });
    }

    updateProductInfo(body: any){
        const headers: HttpHeaders = getHeaders();
        // Actualizar metadata adicional del ebook
        return this.http.put<any>(`${BASE_URL}/ebooks/${body.ProductId}/file/${body.id}`, body, { headers });
    }

    public mapRequiredValues(product: any): any {
        const productInfo: any = {};

        {
            productInfo.id = product.id;
            // Manejar Category que puede venir como ID o como objeto
            productInfo.Category = product.Category || product.category_id || product.Category_id || null;
            productInfo.SKU = product.SKU || '';
            productInfo.Title = product.Title || '';
            productInfo.Description = product.Description || '';
            productInfo.UnitPrice = product.UnitPrice || 0;
            productInfo.CurrencyCode = product.CurrencyCode || 'MXN';
            productInfo.ImgFileUrl = product.ImgFileUrl || '';
            productInfo.CourseModel = product.CourseModel || '';
            productInfo.Objective = product.Objective || '';
            productInfo.Introduction = product.Introduction || '';
            // Manejar Level que puede venir como ID o como objeto
            productInfo.Level = product.Level || product.level_id || product.Level_id || null;
            productInfo.TotalHours = product.TotalHours || 0;
            productInfo.Language = product.Language || 'Español';
            productInfo.LanguageSubtitles = product.LanguageSubtitles || '';
            productInfo.AccessType = product.AccessType || '';
            productInfo.TargetMarket = product.TargetMarket || '';
            productInfo.FileUrl = product.FileUrl || '';
            productInfo.DiscountPrice = product.DiscountPrice || 0;
            productInfo.StartDate = product.StartDate || null;
            productInfo.EndDate = product.EndDate || null;
            productInfo.Teacher = product.Teacher || null;
            productInfo.Percentage = product.Percentage || 0;
            productInfo.Name = product.Name || '';
            productInfo.numberTopics = product.numberTopics || 0;
            productInfo.courseDuration = product.courseDuration || '';
            productInfo.SubCategory = product.SubCategory || product.subcategory_id || '';
            productInfo.teacher_name = product.teacher_name || '';
        }

        return productInfo;
    }

    private editProduct(product: any): any {
        const editProduct = {
            Title: product.Title,
            Family: product.Family,
            Category: product.Category,
            SubCategory: product.SubCategory,
            Brand: product.Brand,
            SKU: product.SKU,
            Model: product.Model,
            Description: product.Description,
            UnitPrice: product.UnitPrice,
            DiscountPrice: product.DiscountPrice,
            CurrencyCode: product.CurrencyCode,
        };
        return editProduct;
    }

    private addBackendStructure(product: any) {
        return {
            Title: product.Title,
            Family: product.Family,
            Category: product.Category,
            SubCategory: product.SubCategory,
            Brand: product.Brand,
            SKU: product.SKU,
            Model: product.Model,
            Description: product.Description,
            UnitPrice: product.UnitPrice,
            DiscountPrice: product.DiscountPrice,
            CurrencyCode: product.CurrencyCode,
            ProductInfo: product.ProductInfo
        };
    }

    private editFeature(feature: any): any {
        const editFeature = {
            CatalogName: feature.CatalogName,
            ValueAlpha: feature.ValueAlpha,
        };
        return editFeature;
    }

    private addBackendStructureFeature(feature: any) {
        return {
            CatalogName: feature.CatalogName,
            ValueAlpha: feature.ValueAlpha
        };

    }


    //metodos para enviar datos de usuario
    updateProfile(id: number, body: any) {
        const headers = getHeaders(); // Obtén los encabezados necesarios
        const url = `${BASE_URL}/user-profile/${id}`; // Reemplaza el ID dinámicamente en la URL
        return this.http.put(url, body, { headers }); // Realiza la solicitud PUT con la URL dinámica
    }
    
    
    /**
     * ========================================
     * ENDPOINTS DE LEADS (PROSPECTOS CRM)
     * ========================================
     * 
     * Backend Endpoints disponibles:
     * 1. POST   /leads                    - Crear nuevo lead (createLead)
     * 2. GET    /leads/:userid            - Listar todos los leads con paginación (listLeads)
     * 3. GET    /v2/leads/:userid         - Listar leads únicos por email (listUniqueLeads)
     * 4. GET    /update-lead/:leadid      - Obtener datos completos de un lead (getLeadData)
     * 5. PUT    /update-lead/:leadid      - Actualizar lead (updateLead)
     * 6. POST   /update-lead/:leadid      - Agregar comentario al lead (addLeadComment)
     * 
     * Query params para GET /leads/:userid:
     * - limit: número de registros por página
     * - offset: inicio de la página
     * - search: buscar por nombre o email
     * - interestTopics: filtrar por temas de interés
     * - status: filtrar por estado
     * - sDate: fecha de inicio
     * - eDate: fecha de fin
     * - funnelId: filtrar por embudo
     * - assignedTo: filtrar por usuario asignado
     * - sortBy: campo por el cual ordenar
     * - sortOrder: dirección de ordenamiento (ASC/DESC)
     */
    
    // Método para obtener leads con paginación, búsqueda, filtros y ordenamiento
    public obtenerLeads(
        userId: number, 
        limit: number, 
        offset: number, 
        status: string, 
        search: string, 
        interestTopics: string, 
        startDate?: string, 
        endDate?: string,
        funnelId?: string,
        assignedTo?: string,
        sortBy?: string,
        sortOrder?: string
    ): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        
        // Validar y limpiar todos los parámetros ANTES de construir HttpParams
        const cleanedUserId = Number.isFinite(userId) ? Math.floor(userId) : 0;
        const cleanedLimit = Number.isFinite(limit) && limit > 0 ? Math.floor(limit) : 10;
        const cleanedOffset = Number.isFinite(offset) && offset >= 0 ? Math.floor(offset) : 0;
        
        // Función auxiliar para limpiar strings
        const cleanString = (value: any): string => {
            if (!value) return '';
            return String(value).trim();
        };
        
        // Función auxiliar para validar y limpiar números que vienen como string
        const cleanNumericString = (value: any): string => {
            if (!value) return '';
            const trimmed = String(value).trim();
            // Validar que sea un número válido
            const num = Number(trimmed);
            if (!Number.isFinite(num) || num < 0) return '';
            return Math.floor(num).toString();
        };
        
        const cleanedStatus = cleanString(status);
        const cleanedSearch = cleanString(search);
        const cleanedInterestTopics = cleanString(interestTopics);
        const cleanedStartDate = cleanString(startDate);
        const cleanedEndDate = cleanString(endDate);
        const cleanedFunnelId = cleanNumericString(funnelId); // Debe ser número
        const cleanedAssignedTo = cleanNumericString(assignedTo); // Debe ser número
        const cleanedSortBy = cleanString(sortBy);
        const cleanedSortOrder = cleanString(sortOrder);
        
        console.log('🧹 ========== CLEANED PARAMETERS ==========');
        console.log('userId:', cleanedUserId, '(original:', userId, ')');
        console.log('limit:', cleanedLimit, '(original:', limit, ')');
        console.log('offset:', cleanedOffset, '(original:', offset, ')');
        console.log('status:', `"${cleanedStatus}"`, '(original:', `"${status}"`, ')');
        console.log('search:', `"${cleanedSearch}"`, '(original:', `"${search}"`, ')');
        console.log('interestTopics:', `"${cleanedInterestTopics}"`, '(original:', `"${interestTopics}"`, ')');
        console.log('==========================================');
        
        // Construir HttpParams sin encoder personalizado (Angular ya hace encoding correcto)
        let params = new HttpParams()
            .set('limit', cleanedLimit.toString())
            .set('offset', cleanedOffset.toString());
        
        console.log('🎯 Parámetros base establecidos - limit:', cleanedLimit, 'offset:', cleanedOffset);
        
        // Agregar parámetros opcionales SOLO si tienen valor (no vacíos)
        if (cleanedStatus !== '') {
            console.log('➕ Agregando status:', cleanedStatus);
            params = params.set('status', cleanedStatus);
        }
        
        if (cleanedSearch !== '') {
            console.log('➕ Agregando search:', cleanedSearch);
            params = params.set('search', cleanedSearch);
        }

        if (cleanedInterestTopics !== '') {
            console.log('➕ Agregando interestTopics:', cleanedInterestTopics);
            params = params.set('interestTopics', cleanedInterestTopics);
        }
    
        if (cleanedStartDate !== '') {
            console.log('➕ Agregando sDate:', cleanedStartDate);
            params = params.set('sDate', cleanedStartDate);
        }
        
        if (cleanedEndDate !== '') {
            console.log('➕ Agregando eDate:', cleanedEndDate);
            params = params.set('eDate', cleanedEndDate);
        }

        if (cleanedFunnelId !== '') {
            console.log('➕ Agregando funnelId:', cleanedFunnelId);
            params = params.set('funnelId', cleanedFunnelId);
        }

        if (cleanedAssignedTo !== '') {
            console.log('➕ Agregando assignedTo:', cleanedAssignedTo);
            params = params.set('assignedTo', cleanedAssignedTo);
        }

        // Solo enviar sortBy y sortOrder JUNTOS si sortBy tiene valor
        // El backend puede requerir ambos o ninguno
        if (cleanedSortBy !== '' && cleanedSortOrder !== '') {
            console.log('➕ Agregando sortBy:', cleanedSortBy, 'y sortOrder:', cleanedSortOrder);
            params = params.set('sortBy', cleanedSortBy);
            params = params.set('sortOrder', cleanedSortOrder);
        } else if (cleanedSortBy !== '') {
            // Si solo tenemos sortBy, usar orden ASC por defecto
            console.log('➕ Agregando sortBy:', cleanedSortBy, 'con sortOrder por defecto: ASC');
            params = params.set('sortBy', cleanedSortBy);
            params = params.set('sortOrder', 'ASC');
        }
        // Si cleanedSortBy está vacío, NO enviar ninguno de los dos parámetros

        const authHeader = headers.get('Authorization');
        
        console.log('🌐 ========== REQUEST LEADS ==========');
        console.log('🔗 URL:', `${BASE_URL}/leads/${cleanedUserId}`);
        console.log('📋 Query Params:', params.toString());
        console.log('📋 Decoded Params:', decodeURIComponent(params.toString()));
        console.log('🔑 Headers:');
        console.log('   - Authorization:', authHeader ? authHeader.substring(0, 20) + '...' : '❌ NO TOKEN');
        console.log('   - Accept:', headers.get('Accept'));
        console.log('💡 Nota: offset = número de página (0-indexed)');
        console.log('🔗 Full URL would be:', `${BASE_URL}/leads/${cleanedUserId}?${params.toString()}`);
        
        // Log detallado de cada parámetro individual
        console.log('📊 Parámetros individuales:');
        params.keys().forEach(key => {
            console.log(`   - ${key}: "${params.get(key)}"`);
        });
        console.log('=====================================');
    
        return this.http.get<any>(`${BASE_URL}/leads/${cleanedUserId}`, { headers, params }).pipe(
            catchError((error) => {
                console.error('🚨 ========== ERROR CAPTURADO EN SERVICIO ==========');
                console.error('📛 Error completo:', error);
                console.error('📛 Status:', error.status);
                console.error('📛 StatusText:', error.statusText);
                console.error('📛 Error.error:', error.error);
                console.error('📛 URL del error:', error.url);
                console.error('====================================================');
                return throwError(() => error);
            })
        );
    }
    

    // Método para obtener Lead por Id (incluye usuario y comentarios)
    // GET /update-lead/:leadid
    public getProspecto(id: number): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/update-lead/${id}`, { headers });
    }

    // Método para agregar comentario a un Lead
    // POST /update-lead/:leadid
    public postProspecto(id: number, body: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/update-lead/${id}`, body, { headers });
    }

    // Método para actualizar Lead (status, funnelId, etc)
    // PUT /update-lead/:leadid
    public ActualizarStatus(id: number, body: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/update-lead/${id}`, body, { headers });
    }

    public enviarloanding(body): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/product-info/`, body, { headers });
    }

    // Método para obtener las lista de órdenes 
    getOrder(status: string, limit: number, offset: number): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/sales?status=${status}&limit=${limit}&offset=${offset}`, { headers });
    }

    // Método para obtener la lista de emails únicos
    getEmails(id: number, limit: number, offset: number, status: string, search: string): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/v2/leads/${id}?limit=${limit}&offset=${offset}&status=${status}&search=${search}`, { headers });
    }

    // Método para crear un nuevo Lead (Prospecto)
    // POST /leads
    updateLead(form: any) {
        const headers = getHeaders();
        return this.http.post<any>(`${BASE_URL}/leads`, form, { headers });
    }

    public postEmail(body:any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/eventEmail`, body, { headers });
    }

    getCampaign(id: any, limit: number, offset: number): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(
          `${BASE_URL}/campaigns/${id}?limit=${limit}&offset=${offset}`, 
          { headers }
        );
    }
    
    getAllCampaigns(id: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(
          `${BASE_URL}/campaigns/${id}`, // Cambiar si el backend usa otro mecanismo.
          { headers }
        );
    }

    // Obtener experiencia laboral
    getJobHistory(userId: number): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get(`${BASE_URL}/UserHistoryJob?userId=${userId}`, { headers });
    }

    // Agregar experiencia laboral
    addJobHistory(jobData: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post(`${BASE_URL}/UserHistoryJob`, jobData, { headers });
    }

    // Actualizar experiencia laboral
    updateJobHistory(jobData: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put(`${BASE_URL}/UserHistoryJob`, jobData, { headers });
    }

    // Eliminar experiencia laboral
    deleteJobHistory(id: number): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.delete(`${BASE_URL}/UserHistoryJob?id=${id}`, { headers });
    }

    // Obtener suscripciones del usuario con información de plan y pago
    getSubscriptionsByUserId(userId: number, limit: number = 100, offset: number = 0): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/subscriptions-customer/${userId}?limit=${limit}&offset=${offset}`, { headers });
    }

    // Método para enviar curso a revisión con endpoint específico
    sendCourseForReview(id: number, product: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<any>(`${BASE_URL}/api/course/${id}`, product, { headers });
    }

    // Método para obtener todos los instructores with paginación
    getTeachers(limit: number = 10, offset: number = 0): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/teachers?limit=${limit}&offset=${offset}`, { headers });
    }

    // Método para crear un nuevo instructor
    createInstructor(instructorData: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/teachers`, instructorData, { headers });
    }

    // Método para crear un nuevo estudiante con email automático
    createStudent(studentData: any): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${BASE_URL}/students`, studentData, { headers });
    }

    // Método para activar cuenta con token
    activateAccount(token: string, password: string): Observable<any> {
        const currentUser = localStorage.getItem('currentUser');
        let authHeaders: HttpHeaders;
        if (currentUser) {
            try {
                const parsedUser = JSON.parse(currentUser);
                authHeaders = new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': parsedUser.token
                });
            } catch {
                authHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
            }
        } else {
            authHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
        }
        const body = { password };
        const endpoint = `${BASE_URL}/auth/activate/${token}`;
        return this.http.post<any>(endpoint, body, { headers: authHeaders });
    }

    // Método para obtener usuarios activos (para asignar leads)
    // GET /users-active
    public getUsersActive(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${BASE_URL}/users-active`, { headers });
    }

    // MÉTODO ALTERNATIVO: Si necesitas un endpoint específico diferente
    // updateCourseForReview(id: number, product: any): Observable<any> {
    //     const headers: HttpHeaders = getHeaders();
    //     return this.http.put<any>(`${BASE_URL}/api/course/${id}`, product, { headers });
    // }
}

